<template>
  <div class="panel-list-page">
    <div class="pl-card">
      <div class="pl-card__header">
        <div class="pl-card__title-wrap">
          <span class="pl-card__icon" aria-hidden="true">
            <CIcon name="iconList"/>
          </span>
          <div>
            <h1 class="pl-card__title">مقادیر ویژگی</h1>
            <p class="pl-card__sub">مدیریت مقادیر و قیمت‌های ویژگی اضافی</p>
          </div>
        </div>
        <div class="pl-toolbar">
          <button
            type="button"
            class="pl-btn pl-btn--ghost"
            @click="$router.push({ path: '/dashboard/products/additional-options' })"
          >
            <CIcon name="iconChevronRight"/>
            <span>بازگشت به ویژگی‌ها</span>
          </button>
          <button type="button" class="pl-btn pl-btn--primary" @click="openCreateModal()">
            <CIcon name="iconPlus"/>
            <span>افزودن مقدار جدید</span>
          </button>
        </div>
      </div>

      <div class="pl-card__body">
        <CDataTableFixed
          :items="items"
          :fields="fields"
          :items-per-page="20"
          hover
          sorter
          pagination
          :noItemsView="{ noItems: 'مقداری یافت نشد' }"
        >
          <template #no-items-view>
            <div class="pl-empty">
              <span class="pl-empty__icon" aria-hidden="true">
                <CIcon name="iconList"/>
              </span>
              <p class="pl-empty__title">مقداری یافت نشد</p>
              <p class="pl-empty__sub">برای این ویژگی، یک مقدار جدید اضافه کنید.</p>
              <button type="button" class="pl-btn pl-btn--primary" @click="openCreateModal()">
                <CIcon name="iconPlus"/>
                <span>افزودن مقدار جدید</span>
              </button>
            </div>
          </template>

          <template #row="{ item }">
            <td>
              <span class="pl-muted">{{ item.row_id + 1 }}</span>
            </td>
          </template>

          <template #value="{ item }">
            <td>
              <span class="pl-name">{{ item.value }}</span>
            </td>
          </template>

          <template #price="{ item }">
            <td>
              <span class="pl-muted">{{ item.price }}</span>
            </td>
          </template>

          <template #is_default="{ item }">
            <td>
              <CInputRadio
                @click="set_is_default(item)"
                :checked.sync="item.is_default"
              />
            </td>
          </template>

          <template #operation="{ item }">
            <td class="pl-ops-cell">
              <div class="pl-ops">
                <button
                  type="button"
                  class="pl-icon-btn pl-icon-btn--warn"
                  title="ویرایش"
                  @click="openEditModal(item)"
                >
                  <CIcon name="iconEdit"/>
                </button>
                <button
                  type="button"
                  class="pl-icon-btn pl-icon-btn--danger"
                  title="حذف"
                  @click="delete_dialog(item)"
                >
                  <CIcon name="iconTrash"/>
                </button>
              </div>
            </td>
          </template>
        </CDataTableFixed>
      </div>
    </div>

    <CModal
      :show.sync="form_modal"
      :centered="true"
      size="lg"
      :title="status_form == 0 ? 'افزودن مقدار جدید' : 'ویرایش مقدار'"
      @update:show="onFormModalToggle"
    >
      <div class="pl-form">
        <CRow>
          <CCol col="12" md="6">
            <CInput
              v-model="name"
              class="required"
              label="عنوان مقدار"
              placeholder="عنوان مقدار"
            />
          </CCol>
          <CCol col="12" md="6">
            <CInput
              v-model="price"
              class="required"
              label="مبلغ اضافی"
              placeholder="مبلغ اضافی"
            />
          </CCol>
        </CRow>
      </div>
      <template #footer>
        <button type="button" class="pl-btn pl-btn--ghost" @click="closeFormModal()">انصراف</button>
        <button type="button" class="pl-btn pl-btn--primary" @click="login()">
          <CIcon name="iconCheck"/>
          <span>{{ status_form == 0 ? 'ثبت مقدار' : 'ذخیره تغییرات' }}</span>
        </button>
      </template>
    </CModal>
  </div>
</template>

<script>
import axios from "@/api/http";
import {bus} from "../../../main";


export default {
  name: 'Login',
  data() {
    return {
      form_modal: false,
      confirm_delete_name:new Date().getTime()+"_"+this.$vnode.tag,

      name: '',
      type: 1,

      summary:'',
      price:'0',
      items: [],
      fields: [
        {key: 'row',label: '#', _style: 'width:10%'},
        {key: 'value',label: 'عنوان مقدار', _style: 'width:10%'},
        {key: 'price',label: 'مبلغ', _style: 'width:10%'},
        {key: 'is_default',label: 'پیشفرض', _style: 'width:10%'},
        {key: 'operation', _style: 'width:40%;'},
      ],
      status_form: 0
    }
  }, mounted() {
    bus.$on(this.confirm_delete_name, (data) => {
      // alert(data);
      if (data == 'true') {
        this.delete_item();

      } else {
        this.status_form = 0;
      }
    });
    this.get_categories();
  }, watch: {},
  methods: {
    openCreateModal() {
      this.cancel_form();
      this.form_modal = true;
    },
    openEditModal(item) {
      this.editDetails(item);
      this.form_modal = true;
    },
    closeFormModal() {
      this.form_modal = false;
      this.cancel_form();
    },
    onFormModalToggle(show) {
      if (!show) {
        this.cancel_form();
      }
    },
    cancel_form() {
      this.name = '';
      this.price = '0';
      this.status_form = 0;
    },
    get_style(color) {
      return {
        myStyle: {
          backgroundColor: color
        }
      }
    },
    editDetails(item) {
      this.name = item.title;
      this.status_form = item.id;

    },
    set_is_default(item){
      console.log("item set default",item)
      let self = this;
      const formData = new FormData()
      let  url = "/api/admin/product/set_additional_option_value_default";

      formData.append("option_id",this.$route.params.id)
      formData.append('id', item.id)


      axios.post(url, formData, {}).then((res) => {
        self.$root.modal_component.show_api_response_modals(res);

        self.get_categories();

      })

          .catch(function (error) {

            console.log(error);
          });

    },
    get_categories() {
      var self = this;
      var formData = new FormData();
      formData.append("option_id",this.$route.params.id)
      axios.post('/api/admin/product/get_additional_option_values', formData, {}).then(function (response) {

        var content_cats = response.data;

        self.items = content_cats.tags.map((item, row_id) => {
          return {...item, row_id}
        });

      })
          .catch(function (error) {

            console.log(error);
          });

    },

    login() {


      let self = this;
      const formData = new FormData()
      let url;
      if (this.status_form == 0) {
        url = "/api/admin/product/add_additional_option_value";
      } else {
        url = "/api/admin/product/update_additional_option_value";
        formData.append('id', this.status_form)

      }
      formData.append("option_id",this.$route.params.id)

      formData.append('value', this.name);
      formData.append('price', this.price);



      axios.post(url, formData, {}).then((res) => {
        self.$root.modal_component.show_api_response_modals(res);

        self.status_form = 0;
        self.name = '';
        self.form_modal = false;
        self.get_categories();

      })

          .catch(function (error) {

            console.log(error);
          });

    },
    delete_dialog(item) {
      this.$root.modal_component.show_confirm_modal('اخطار', "آیا مایل به حذف این ردیف هستید؟", ['تایید'], this.confirm_delete_name);
      this.status_form = item.id;

    },
    delete_item() {


      let self = this;
      const formData = new FormData()
      let url;
      url = "/api/admin/product/delete_additional_option_value";

      formData.append("option_id",this.$route.params.id)

      formData.append('id', this.status_form);

      axios.post(url, formData, {}).then((res) => {
        self.$root.modal_component.show_api_response_modals(res);

        self.status_form = 0;
        self.get_categories();

      })
          .catch(function (error) {

            console.log(error);
          });
// this.get_categories();
      // this.$router.push({ path: '/posts/'});
    },


  }
}


</script>
